import { ElementController, FORM_EVENT, httpGet } from 'js-common';

import { MESSAGES_CONTROLLER_ID } from './constants';

const TRANSITION_REMOVE_ALL_TIMEOUT = 5000;

/**
 * Controller for Django messages. Used to display Django messages directly
 * after form submit, without page refresh.
 */
export default class Messages extends ElementController {
  static id = MESSAGES_CONTROLLER_ID;

  /**
   * DOM ready.
   */
  init() {
    this.on(document.body, FORM_EVENT.response, this.handleFormResponse);
    this.on(this.root, 'click', 'button', this.handleCloseClick);
    this.handleMessageTimeout();
  }

  /**
   * Set timeout on messages.
   */
  handleMessageTimeout() {
    const messages = this.selectAll('li');
    messages.forEach((message) =>
      setTimeout(this.removeMessage, TRANSITION_REMOVE_ALL_TIMEOUT, message),
    );
  }

  /**
   * Remove message element from the dom
   *
   * @param {HTMLElement} message - Message to remove
   */
  removeMessage(message) {
    clearTimeout(message);

    message.remove();
  }

  /**
   * Act on form response and display messages.
   */
  handleFormResponse = async () => {
    const htmlResponse = await httpGet('/messages-html/');

    this.root.insertAdjacentHTML('afterbegin', htmlResponse);
    this.handleMessageTimeout();
  };

  /**
   * Remove the message node when the close button is clicked.
   *
   * @param {MouseEvent} e - Click event.
   */
  handleCloseClick = (e) => {
    e.currentTarget.closest('li').remove();
  };
}
